import { AllowanceProposalFormData } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/AllowanceProposalForm/data/formData';
import {
  CommonFormDataToLegacyPayloadProps,
  LegacyProposalRequestProps,
  mapSubmitDataUtils,
  submitLegacyProposal,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common';

import { LegacyProposalAPI } from '../../../data';

export type AllowanceSubmitData = {
  fEmplId: number;
  fEmplSubUId?: string;
  fAllowanceProposalStartDate: string;
  fAllowanceProposalEndDate: string;
  fAllowanceProposalInfo: string;
  fAllowanceProposalType: string;
  fAllowanceProposalFrequency: string;
  fAllowanceProposalAmount: string;
  fAllowanceProposalTaxableAmount: string;
  fAllowanceProposalHrId: number;
  fAllowanceProposalHigherMgrId: number;
  fAllowanceProposalManagerId: number;
  fAllowanceProposalStatus: string;
};

export const mapFormDataToLegacyPayload = (
  props: CommonFormDataToLegacyPayloadProps<AllowanceProposalFormData>,
): AllowanceSubmitData => {
  const {
    data,
    isHRUser,
    decision,
    requestProps: { employeeId, proposalId },
  } = props;
  const {
    submissionResponsibleHR,
    submissionDateInFormat,
    submissionNumberAsString,
    submissionProposalStatus,
  } = mapSubmitDataUtils({ defaultSubmissionDateFormat: 'YYYY-MM-DD' });
  return {
    fEmplId: +data.employmentId || employeeId,
    fEmplSubUId: proposalId,
    fAllowanceProposalStartDate: submissionDateInFormat(data.startDate),
    fAllowanceProposalEndDate: submissionDateInFormat(data.endDate),
    fAllowanceProposalInfo: data.allowanceInfo || '',
    fAllowanceProposalType: data.allowanceType,
    fAllowanceProposalFrequency: data.allowanceFrequency,
    fAllowanceProposalAmount: submissionNumberAsString(data.allowanceAmount),
    fAllowanceProposalTaxableAmount: submissionNumberAsString(
      data.taxableAmount,
    ),
    fAllowanceProposalManagerId: -1,
    fAllowanceProposalHigherMgrId: -1,
    fAllowanceProposalHrId: submissionResponsibleHR(data.responsibleHR),
    fAllowanceProposalStatus: submissionProposalStatus({ isHRUser, decision }),
  };
};

export const submitAllowanceProposal = async (
  data: AllowanceSubmitData,
  requestProps: LegacyProposalRequestProps,
) =>
  submitLegacyProposal<AllowanceSubmitData>(
    LegacyProposalAPI.AllowanceProposal,
    data,
    requestProps,
  );
